import { post } from '@/utils/http';

export const postMessage = (data) => {
    return post('messages', data);
}